import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Tracking from './Tracking';
import messages from '../../../locale/messages';
import { getMapViewData } from '../../../actions/siteadmin/Tracking/getMapViewData';
import { restrictUrls } from '../../../helpers/adminPrivileges';

async function action({ store, intl }) {
  const title = intl.formatMessage(messages.tracking);
  let adminPrivileges = store.getState().account && store.getState().account.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/login' }
  }

  // Admin restriction
  if (!restrictUrls('/siteadmin/tracking', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  await store.dispatch(getMapViewData("all", "today", 10));

  return {
    title,
    component: (
      <AdminLayout><Tracking /></AdminLayout>
    )
  }
}

export default action;
